import React, { Component } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import { axiosGet, axiosPost } from "../../../utils/AxiosApi";
import { fileIconPath, URL } from "../../../utils/Constants";
import { displayErrorAlert } from "../../../utils/Utils";
import DragDropFile from "../../../UI/DragDropFile";

export class ImportRecruitment extends Component {
  state = {
    spinner: false,
    recruitmentFile: null,
    iconPreview: null,
    fileName: null,
  };

  generateFormat = () => {
    this.setState(
      {
        spinner: true,
      },
      () => {
        axiosGet(
          URL.generateRecruitmentFormat,
          (response) => {
            if (response.status === 200) {
              this.setState({
                spinner: false,
              });
              window.open(
                URL.downloadBill + response.data.path,
                "_blank"
              );
            }
          },
          (err) => {
            displayErrorAlert(err);
            this.setState({
              spinner: false,
            });
          }
        );
      }
    );
  };

  handleChange = (e) => {

    let files = e.target.files[0];
    let icon;
    let fileName;
    if (!!files) {
      const extension = files.name.split('.').pop().toLowerCase();
      const isFileSupported = extension.match(/(xlsx|xls)/);
      if (fileIconPath[extension] && !!isFileSupported) {
        icon = fileIconPath[extension];
        fileName = files.name;
        this.setState({
          recruitmentFile: files,
        });
      } else {
        icon = fileIconPath.default;;
        fileName = fileName = files.name + " appears to be in a format that is not supported."
        this.setState({
          recruitmentFile: null,
        });
      }
      this.setState({
        fileName: fileName,
        iconPreview: icon,
      });
    } else {
      this.setState({
        recruitmentFile: null,
        fileName: null,
        iconPreview: null,
      });
    }
  };

   handleFileDrop = (e, name) => {
          let files = e.dataTransfer.files[0];
          let icon;
          let fileName;
          if (files.length > 1) {
                swal("Oops", "Please select only one file");
              } else {
                  if(!!files){
                      const extension = files.name.split('.').pop().toLowerCase();
                      const isFileSupported = extension.match(/(xlsx|xls)/);
                      if(fileIconPath[extension] && !!isFileSupported){
                          icon = fileIconPath[extension];
                          fileName = files.name;
                          this.setState({
                            recruitmentFile: files,
                          });
                      }else{
                          icon =fileIconPath.default;;
                          fileName = fileName = files.name + " appears to be in a format that is not supported."
                          this.setState({
                            recruitmentFile: null,
                          });
                      }
                      this.setState({
                        fileName: fileName,
                        iconPreview: icon,
                      });
                  }else{
                    this.setState({
                      recruitmentFile: null,
                      fileName: null,
                      iconPreview: null,
                    });
                  }
              }
        };

  importFile = () => {
    let formData = new FormData();
    if (this.state.recruitmentFile !== null) {
      formData.append("file", this.state.recruitmentFile);

      this.setState(
        {
          spinner: true,
        },
        () => {
          axiosPost(
            URL.importRecruitment,
            formData,
            (response) => {
              if (response.status === 200) {
                this.setState({
                  spinner: false,
                  recruitmentFile: null,
                  fileName: null,
                  iconPreview: null,
                });
                swal("Success", "Recruitment data imported successfully.");
              }
            },
            (err) => {
              swal("Opps!",err.response.data.message);
              this.setState({
                spinner: false,
              });
            }
          );
        }
      );
    } else {
      swal("Oops", "Empty file cannot be imported");
    }
  };
  render() {
    return (
      <>
        {this.state.spinner ? (
          <div className="fullWindow-Spinner">
            <div>
              <Spinner color="white"></Spinner>
            </div>
            <div style={{ fontSize: "16px", marginTop: "15px" }}>
              Please wait...
            </div>
          </div>
        ) : null}
        <div className="container">
          <div className="d-flex justify-content-between py-2 align-items-center">
            <div className="">
              To import the recruitment data, the format should be according to
              the system. Please do not change the content of the file.
              <br /> Genrete the recruitment format here.
              <br />
              <span className="text-danger font-italic">
                [Note: all columns in the file are mandatory]
              </span>
            </div>
            {
              <button
                className="tt-button tt-button-primary"
                onClick={this.generateFormat}
              >
                Generate Format
              </button>
            }
          </div>
          <div className="py-2">
            <DragDropFile
              multiple={false}
              handleChange={(e) => this.handleChange(e)}
              name="recruitmentFile"
              handleFileDrop={this.handleFileDrop}
              files={this.state.recruitmentFile}
              accept=".xlsx, .xls"
              iconPreview={this.state.iconPreview}
              fileName={this.state.fileName}
              id="recruitmentFile"
            />
            <div className="mt-3 text-right">

              <button
                className="tt-button tt-button-primary"
                onClick={this.importFile}
              >
                Import
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ImportRecruitment;
